module.exports = __webpack_public_path__ + "img/catalog-category-aksessuary-dlya-ochkov.ac1d216.png?v=1756374799800";